/**
 * Footer V2 — accordion for non-menu column blocks on mobile (link_list menus stay expanded).
 */
document.querySelectorAll(".footer-v2-block").forEach(function (block, index) {
  if (block.classList.contains("footer-v2-block--menu")) return;
  block.addEventListener("click", function () {
    if (index === 2) return;
    var wasActive = block.classList.contains("active");
    document.querySelectorAll(".footer-v2-block").forEach(function (el) {
      el.classList.remove("active");
    });
    if (!wasActive) block.classList.add("active");
  });
});

/**
 * Scroll-reveal slideIn on .footer-v2__content-bottom sometimes leaves opacity ~0.01
 * (static rule + animation / timing). Force final visible state via animationend,
 * duration-based fallback, and when scroll-trigger--offscreen is removed.
 */
function initFooterV2BottomReveal() {
  document.querySelectorAll(".footer-v2__content-bottom.scroll-trigger.animate--slide-in").forEach(function (el) {
    if (el.dataset.footerV2BottomRevealInit) return;
    el.dataset.footerV2BottomRevealInit = "1";

    function solidify() {
      if (el.dataset.footerV2BottomRevealDone) return;
      el.dataset.footerV2BottomRevealDone = "1";
      el.classList.add("footer-v2__content-bottom--reveal-done");
      el.style.setProperty("opacity", "1", "important");
      el.style.setProperty("transform", "translateY(0)", "important");
    }

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      solidify();
      return;
    }

    function maxAnimationDurationSec() {
      var cs = window.getComputedStyle(el);
      var raw = cs.animationDuration || "0s";
      var maxSec = 0;
      raw.split(",").forEach(function (part) {
        part = part.trim();
        if (!part || part === "0s") return;
        var n = parseFloat(part);
        if (part.indexOf("ms") !== -1) n /= 1000;
        if (!isNaN(n) && n > maxSec) maxSec = n;
      });
      return maxSec > 0 ? maxSec : 0.65;
    }

    function scheduleOpacityFallback() {
      var delayMs = Math.round(maxAnimationDurationSec() * 1000) + 250;
      window.setTimeout(function () {
        var op = parseFloat(window.getComputedStyle(el).opacity);
        if (!el.dataset.footerV2BottomRevealDone && (isNaN(op) || op < 0.95)) {
          solidify();
        }
      }, delayMs);
    }

    function onAnimEnd(e) {
      if (e.target !== el) return;
      solidify();
    }

    el.addEventListener("animationend", onAnimEnd);
    el.addEventListener("webkitAnimationEnd", onAnimEnd);

    window.requestAnimationFrame(function () {
      var cs = window.getComputedStyle(el);
      if (cs.animationName === "none" || cs.animationDuration === "0s") {
        solidify();
        return;
      }
      scheduleOpacityFallback();
    });

    if (!el.classList.contains("scroll-trigger--offscreen")) {
      scheduleOpacityFallback();
    } else {
      var mo = new MutationObserver(function () {
        if (!el.classList.contains("scroll-trigger--offscreen")) {
          scheduleOpacityFallback();
          mo.disconnect();
        }
      });
      mo.observe(el, { attributes: true, attributeFilter: ["class"] });
    }
  });
}

function runFooterV2BottomRevealInit() {
  initFooterV2BottomReveal();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runFooterV2BottomRevealInit);
} else {
  runFooterV2BottomRevealInit();
}
window.addEventListener("load", runFooterV2BottomRevealInit);
document.addEventListener("shopify:section:load", runFooterV2BottomRevealInit);
